const sortingStructureBySequence = async (data) => {
    await data.sort(function (a, b) {
        var keyA = a.sequence,
            keyB = b.sequence;
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
    });

    return data;
};

export default sortingStructureBySequence;
